import store from '../store';
import { errorResponseAction } from '../components/Form/FormContainer/ducks';

export function getErrorsMessages({ data: { errors } }) {
  return Array.from(new Set(errors.map((error) => error.message.nl)));
}

export function handleIfSuccessResponseHasErrors(response) {
  if (!response.data.success) {
    const errorMessages = getErrorsMessages(response);

    store.dispatch(errorResponseAction(errorMessages));
  }
}
